import {observable} from 'mobx';
import {IDesignUIState} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignUIState';

export class GuideState
{
    @observable
    public props:GuideProps = null;

    @observable
    public json:GuideJson = null;

    @observable
    public isDesignLoading:boolean = false;

    public tour:GuideTour = new GuideTour();

    public video:GuideVideo = new GuideVideo();
}

export class GuideProps
{
    hasGuide:boolean;
    guideUrl:string;
    lastOpenedGuidePage:number;
}

export class GuideJson
{
    @observable designId:number;
    @observable steps:GuideStep[];

    initialUIState:IDesignUIState;

    // public static fromResponse(response:any):GuideJson
    // {
    //     let guide:GuideJson = new GuideJson();
    //
    //     guide.designId = response.designId;
    //     guide.steps = response.steps;
    //
    //     return guide;
    // }
}

export class GuideStep
{
    // spaceId:number;
    // designId?:number;
    design?:any;
    versionName:string;
    title:string;
    blocks:GuideBlock[];
}

export class GuideBlock
{
    description:string;
    video?:string;
    videoPreview?:string;
    comments?:GuideComment[];
}

export class GuideComment
{
    text?:string;
    tip?:string;
}

export class GuideTour
{
    @observable isVisible:boolean = false;
    @observable panelRef:HTMLElement = null;
    @observable panelContentRef:HTMLElement = null;
}

export class GuideVideo
{
    @observable isVisible:boolean = false;
    @observable url:string = null;
}
